<nav class="topnav">
  <div class="topnav-brand">
    <a href="https://www.kairhos.com/" target="_blank" class="brand-logo">
      <img src="assets/logo.svg" class="logo-kairhos" alt="Kairhos" />
    </a>
  </div>

  <div class="topnav-spacer"></div>

  <div class="topnav-actions">
    <div class="topnav-label">
      <img src="assets/injest-iq.svg" alt="Injest.IQ" class="topnav-icon" />
      Injest.IQ
    </div>
  </div>
</nav>
